// Direct contact block, footer and legal pages (spec c.7 §9–10, COO decision 9).
// Legal entity name and postal address are unknown: leave undefined, never invent them.

export type Contact = {
  name: string;
  /** i18n key for the contact's role line. */
  roleKey: string;
  email: string;
  /** E.164, for `tel:` links. */
  phone: string;
  phoneDisplay: string;
  /** Optional +52 WhatsApp number (E.164). */
  whatsapp?: string;
  careersEmail: string;
  legalEntity?: string;
  city?: string;
};

export const contact: Contact = {
  name: "Raul Garcia Bonifaz",
  roleKey: "team.raul.role",
  email: "raul.garcia@duxtrans.com",
  phone: "+12108031773",
  phoneDisplay: "+1 (210) 803-1773",
  careersEmail: "careers@duxtrans.com",
};
